import { render, staticRenderFns } from "./LegacyPageContent.vue?vue&type=template&id=464077ae"
import script from "./LegacyPageContent.vue?vue&type=script&lang=ts"
export * from "./LegacyPageContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports